import AsyncStorage from "@react-native-async-storage/async-storage"
import { createClient, SupabaseClient } from "@supabase/supabase-js"
import Constants from "expo-constants"
import { Platform } from "react-native"
import "react-native-url-polyfill/auto"

declare const process: {
  env: Record<string, string | undefined>
}

type SupabaseRuntimeConfig = {
  url?: string
  anonKey?: string
  supabaseUrl?: string
  supabaseAnonKey?: string
}

let cachedClient: SupabaseClient | null = null

function readExtraConfig(): SupabaseRuntimeConfig {
  const extra = Constants.expoConfig?.extra as SupabaseRuntimeConfig | undefined
  return {
    url: extra?.url ?? extra?.supabaseUrl,
    anonKey: extra?.anonKey ?? extra?.supabaseAnonKey,
  }
}

export function getSupabaseConfig(): SupabaseRuntimeConfig {
  const extra = readExtraConfig()

  return {
    url: process.env.EXPO_PUBLIC_SUPABASE_URL ?? extra.url,
    anonKey:
      process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY ??
      process.env.EXPO_PUBLIC_SUPABASE_KEY ??
      extra.anonKey,
  }
}

export function isSupabaseConfigured() {
  const config = getSupabaseConfig()
  return Boolean(config.url && config.anonKey)
}

function canPersistAuthSession() {
  return Platform.OS !== "web" || "window" in globalThis
}

export function getSupabaseClient() {
  const config = getSupabaseConfig()

  if (!config.url || !config.anonKey) {
    return null
  }

  if (!cachedClient) {
    const persistAuthSession = canPersistAuthSession()

    cachedClient = createClient(config.url, config.anonKey, {
      auth: {
        storage: persistAuthSession ? AsyncStorage : undefined,
        persistSession: persistAuthSession,
        detectSessionInUrl: persistAuthSession && Platform.OS === "web",
        autoRefreshToken: true,
        flowType: "pkce",
      },
      global: {
        headers: {
          "X-Client-Info": "emo-expo-app",
        },
      },
    })
  }

  return cachedClient
}
